export const getProfileUrl = () => process.env.VUE_APP_PROFILE_URL;
